import { z } from 'zod';
import { baseEntityFields } from './base.js';

/** Metadonnees d'un binaire Cloud Storage lie a une fiche. */
export const StoredFileSchema = z.object({
  ...baseEntityFields,
  orgId: z.string().min(1),
  parentCollection: z.string().min(1),
  parentId: z.string().min(1),
  storagePath: z.string().min(1),
  name: z.string().min(1).max(255),
  nameKey: z.string().min(1),
  mimeType: z.string().min(1),
  size: z.number().int().nonnegative(),
  // `photo` : la photo de reference de la fiche (`docs/socle/couleur-photo-fiche.md`), jamais une piece jointe.
  kind: z.enum(['attachment', 'export', 'photo']),
  status: z.enum(['pending', 'ready']),
});

export type StoredFile = z.infer<typeof StoredFileSchema>;
export type StoredFileKind = StoredFile['kind'];
